import { Sheet2 } from "../../core/services/mocks/sheet2";
import { Sheet5 } from "../../core/services/mocks/sheet5";
import { ObraApp } from "../../models/obraApp.model";

export function FormulasCreateProgram() {
  /*col: AB
      Monto Contractual Dólares
      formula: =SI(N2="";"";AA2*N2)*/
  const getMontoContractualDolares = ({montoInicial, tipoCambio}: ObraApp) => {
    let result = null;
    if(!montoInicial) {
      result = null
    } else {
      result = tipoCambio * montoInicial
    }
    return result
  };

  /*
    col: AC
    Monto Contractual inicial en dólares (en millones)
    formula: =SI(AB3="";"";AB3/1000000)
  */
  const getMontoContractualEnDolaresMillones = (
    {montoContractualDolares}: ObraApp
  ): number | null => {
    let result = null;
    if (montoContractualDolares) {
      result = Number((montoContractualDolares / 1000000).toFixed(2));
    }
    return result;
  };

  /*
   col: AD
   Monto Contractual vigente modificado en dólares
   formula: =+CW3
   */
  const getMontoContractualVigenteModificadoDolares = ({montoContractualVigenteModificadoDolares}: ObraApp) => {
    let result = null;
    result = montoContractualVigenteModificadoDolares;
    return result;
  };

  /*
   col: AE
   Monto Contractual vigente modificado en dólares en millones
   formula: =SI(AD3="";"";AD3/1000000)
   */
  const getMontoContractualVigenteModificadoDolaresEnMillones = (
    {montoContractualVigenteModificadoDolares}: ObraApp
  ): number | null => {
    let result = null;
    if (montoContractualVigenteModificadoDolares) {
      result = montoContractualVigenteModificadoDolares / 1000000;
    }
    return result;
  };

  /*
   col: AF
   Total pago hasta la fecha en dólares
   formula: =SI(X3="";"";X3*CU3)
   */
  const getTotalPagoHastaLaFechaDolares = ({pagado, tipoCambio}: ObraApp): number | null => {
    let result = null;
    if (pagado && tipoCambio) {
      result = Number((pagado * tipoCambio).toFixed(2));
    }
    return result;
  };

  /*
    col: AG
    Clasificación por km
    formula: =SI(L5>Sheet5!$J$7;
     SI(L5<=Sheet5!$K$7;Sheet5!$I$7;
        SI(L5<=Sheet5!$K$8;Sheet5!$I$8;
           SI(L5<=Sheet5!$K$9;Sheet5!$I$9;Sheet5!$I$10)
            )
         ); "Otro"
      )
    */
  const getClasificacionporkm = ({longitudKm}: ObraApp): string => {
    let result = null;
    if (longitudKm! > Sheet5.rangoKm[0].De) {
      if (longitudKm! <= Sheet5.rangoKm[0].Hasta) {
        result = Sheet5.rangoKm[0].Rango;
      } else if (longitudKm! <= Sheet5.rangoKm[1].Hasta) {
        result = Sheet5.rangoKm[1].Rango;
      } else if (longitudKm! <= Sheet5.rangoKm[2].Hasta) {
        result = Sheet5.rangoKm[2].Rango;
      } else {
        result = Sheet5.rangoKm[3].Rango;
      }
    } else {
      result = "Otro";
    }
    return result;
  };

  /*col: AH
    Clasificación por montos
    formula: =SI(AD3="";"Otro";
                SI(AD3>Sheet5!$O$7;
                    SI(AD3<=Sheet5!$P$7;Sheet5!$N$7;
                        SI(AD3<=Sheet5!$P$8;Sheet5!$N$8;
                        SI(AD3<=Sheet5!$P$9;Sheet5!$N$9;
                                SI(AD3<=Sheet5!$P$10;Sheet5!$N$10)
                            )
                            )
                        ); "Otro"
                    ))
    */
  const getClasificacionPorMontos = ({montoContractualVigenteModificadoDolares}: ObraApp): string => {
    let result = null;
    if (montoContractualVigenteModificadoDolares! >= Sheet5.rangoMontos[0].De) {
      if (montoContractualVigenteModificadoDolares! <= Sheet5.rangoMontos[0].Hasta) {
        result = Sheet5.rangoMontos[0].Rango;
      } else if (montoContractualVigenteModificadoDolares! <= Sheet5.rangoMontos[1].Hasta) {
        result = Sheet5.rangoMontos[1].Rango;
      } else if (montoContractualVigenteModificadoDolares! <= Sheet5.rangoMontos[2].Hasta) {
        result = Sheet5.rangoMontos[2].Rango;
      } else {
        result = Sheet5.rangoMontos[3].Rango;
      }
    } else {
      result = "Otro";
    }
    return result;
  };

  /*col: AI
    Precio inicial por km (millones)
    formula:=+SI.ERROR(AC5/L5;"")
    */
  const getPrecioInicialPorKmMillones = ({montoContractualDolaresEnMillones, longitudKm}: ObraApp) => {
    let result = null;
    if (montoContractualDolaresEnMillones && longitudKm) {
      result = montoContractualDolaresEnMillones / longitudKm;
    } else {
      result = 0;
    }
    return result;
  };

  /*col: AJ
       Precio vigente por km (millones)
       formula:=+SI.ERROR(AC5/L5;"")
       */
  const getPrecioVigentePorKmMillones = ({montoContractualVigenteModificadoDolaresEnMillones, longitudKm}: ObraApp): number | null => {
    let result = null;
    if (montoContractualVigenteModificadoDolaresEnMillones && longitudKm) {
      result = Number((montoContractualVigenteModificadoDolaresEnMillones / longitudKm).toFixed(2));
    }
    return result;
  };

  /*
    col: AK
    Plazo contractual vigente PASO INTERMEDIO
    Formula: =SI.ERROR(SI(O(R3="";T3="");"";SIFECHA(R3;T3;"M"));"")
    */
  const getPlazoContractualVigentePasoIntermedio = (
    item: ObraApp
  ): number | null => {
    let result = null;
    const R: any = item.fechaInicio;
    const T: any = item.fechaFinalizacionVigente;
    if (!R || !T) {
      result = 0;
    } else {
      const diff = Math.abs(R - T);
      const avance = Number((((diff / (1000 * 3600 * 24)) / 365) * 12).toFixed());
      result = avance;
    }
    return result;
  };

  /*
    col: AL
    Plazo contractual vigente
    Formula: =SI(AK3<S3;AK3+1;AK3)
   */
  const getPlazoContractualVigente = (item: ObraApp): number | null => {
    let result = null;
    const AK = item.plazoContractualVigentePasoIntermedio!;
    const S = item.plazoInicialMeses;
    if (AK < S!) {
      result = AK + 1;
    } else {
      result = AK;
    }
    return result;
  };

  /*
    col: AM
    Clasificación por plazo
    Formula:
    =SI(AK3="";"Otro";
    SI(AK3>Sheet5!$J$15;
     SI(AK3<=Sheet5!$K$15;Sheet5!$I$15;
        SI(AK3<=Sheet5!$K$16;Sheet5!$I$16;
           SI(AK3<=Sheet5!$K$17;Sheet5!$I$17;Sheet5!$I$18)
            )
         ); "Otro"
      ))
    */
  const getClasificacionPorPlazo = (item: ObraApp) => {
    let result = null;
    const AK = item.plazoContractualVigentePasoIntermedio;
    if (AK! > Sheet5.rangoPlazo[0].De) {
      if (AK! <= Sheet5.rangoPlazo[0].Hasta) {
        result = Sheet5.rangoPlazo[0].Rango;
      } else if (AK! <= Sheet5.rangoPlazo[1].Hasta) {
        result = Sheet5.rangoPlazo[1].Rango;
      } else if (AK! <= Sheet5.rangoPlazo[2].Hasta) {
        result = Sheet5.rangoPlazo[2].Rango;
      } else if (AK! <= Sheet5.rangoPlazo[3].Hasta) {
        result = Sheet5.rangoPlazo[3].Rango;
      }
    } else {
      result = "Otro";
    }
    return result;
  };

  /*
   col: AN
   Sobreplazo (meses) calculado 
   Formula: =SI(O(AL3="";S3="");"";SI(((AL3-S3)/S3)>0;(AL3-S3)/S3;""))
   */
  const getSobreplazoCalculadoMeses = (item: ObraApp) => {
    let result = null;
    const AL = item.plazoContractualVigente;
    const S = item.plazoInicialMeses;
    if (!AL || !S) {
      result = 0;
    } else {
      if ((AL - S) / S > 0) {
        result = Number(((AL - S) / S).toFixed(2));
      } else {
        result = 0;
      }
    }
    return result;
  };

  /* 
   col: AO
   Clasificación por sobreplazo
   Formula: 
   =SI(AN21="";"Otro";
    SI(AN21>=Sheet5!$J$23;
     SI(AN21<=Sheet5!$K$23;Sheet5!$I$23;
        SI(AN21<=Sheet5!$K$24;Sheet5!$I$24;
           SI(AN21<=Sheet5!$K$25;Sheet5!$I$25;Sheet5!$I$26)
            )
         ); "Otro"
      ))
   */
  const getClasificacionPorSobreplazo = (item: ObraApp): string | null => {
    let result = null;
    const AN = parseFloat(item.sobreplazoMesesCalculado!);
    if (AN >= Sheet5.rangoSobreplazo[0].De) {
      if (AN < Sheet5.rangoSobreplazo[0].Hasta) {
        result = Sheet5.rangoSobreplazo[0].Rango;
      } else if (AN < Sheet5.rangoSobreplazo[1].Hasta) {
        result = Sheet5.rangoSobreplazo[1].Rango;
      } else if (AN < Sheet5.rangoSobreplazo[2].Hasta) {
        result = Sheet5.rangoSobreplazo[2].Rango;
      } else if (AN < Sheet5.rangoSobreplazo[3].Hasta) {
        result = Sheet5.rangoSobreplazo[3].Rango;
      }
    } else {
      result = "Otro";
    }
    return result;
  };

  /* 
   col: AQ
   Avance de plazo PLAZO INTERMEDIO
   Formula: =SI(O(R342="";AP342="");"";SI.ERROR(SIFECHA(R342;AP342;"M");""))
  */
  const getAvancePlazoPlazoIntermedio = (item: ObraApp) => {
    let result = null;
    const R: any = item.fechaInicio;
    const C: any = item.fecha;
    if (!R || !C) {
      result = 0;
    } else {
      const diff = Math.abs(R - C);
      const avance = Number((((diff / (1000 * 3600 * 24)) / 365) * 12).toFixed());
      result = avance;
    }
    return result;
  };

  /* 
   col: AR
   % de avance de plazo
   Formula: =SI(O(AQ342="";AK342="");"";SI.ERROR(AQ342/AK342;""))
   
   */
  const getPorcentajeAvancePlazo = (item: ObraApp) => {
    let result = null;
    const AQ = item.avanceDePlazoPlazoIntermedio;
    const AK = item.plazoContractualVigentePasoIntermedio;
    if (AQ && AK) {
      result = AQ / AK;
    }
    return result;

  };

  /* 
   col: AS
   Estado de avance general
   Formula: 
   =SI(Y342=Sheet2!$D$16;"En inicio";
  SI(O(AR342="";AT342="");"Revisar";
  SI(Y(AR342>=0;AT342>=0;AT342<=0,25);"En inicio";
      SI(AR342/AT342>=1;"Riesgo no identificado";
    SI(AR342/AT342>=0,9;"Riesgo identificado";
     SI(AR342/AT342<0,9;"Riesgo materializado";"Revisar"))))))
   */
  const getEstadoAvanceGeneral = (item: ObraApp) => {
    let result = null;
    const Y = item.estadoEjecucion;
    const AR = item.porcentajeAvanceDePlazo;
    const AT = item.porcentajeAvanceAcumulado;
    if (Y === Sheet2.estadoEjecucion[6].id) {
      result = "En inicio";
    }
    else {
      if (!AR || !AT) {
        result = "Revisar";
      } else if (AR >= 0 && AT >= 0 && AT <= 0.25) {
        result = "En inicio";
      } else if (AR / AT >= 1) {
        result = "Riesgo no identificado";
      } else if (AR / AT >= 0.9) {
        result = "Riesgo identificado";
      } else if (AR / AT <= 0.9) {
        result = "Riesgo Materializado";
      }
    }
    return result;
  };

  /* 
   col: AT
   % avance acumulado
   Formula: =SI(O(AF348="";AD348="");"";SI.ERROR((AF348)/AD348;""))
   */
  const getPorcentajeAvanceAcumulado = (item: ObraApp) => {
    let result = null;
    const AF = item.totalPagoHastaLaFechaDolares;
    const AD = item.montoContractualVigenteModificadoDolares;
    if (!AF || !AD) {
      result = 0;
    } else {
      result = Number((AF / AD).toFixed(2));
    }
    return result;
  };

  /*
  col: AU
  Sobrecostos materializados
  Formula =+SI(O(AD252="";AB252="");"";SI.ERROR(SI(O((AD252-AB252)/AB252=0;Y((AD252-AB252)/AB252>0;(AD252-AB252)/AB252<0,001));"";(AD252-AB252)/AB252);""))
  */
  const getSobrecostosMaterializados = (item: ObraApp) => {
    let result = null;
    const AD = item.montoContractualVigenteModificadoDolares;
    const AB = item.montoContractualDolares;
    if (!AD || !AB) {
      result = 0;
    } else {
      if ((AD - AB) / AB >= 0 && (AD - AB) / AB < 0.001) {
        result = 0;
      } else {
        result = (AD - AB) / AB;
      }
    }
    return result;
  };

  /*
  col: AV
  Clasificación de sobrecostos
  Formula =SI(AU37="";"Otro";
    SI(AU37>=Sheet5!$O$15;
     SI(AU37<=Sheet5!$P$15;Sheet5!$N$15;
        SI(AU37<=Sheet5!$P$16;Sheet5!$N$16;
           SI(AU37<=Sheet5!$P$17;Sheet5!$N$17;Sheet5!$N$18)
            )
         ); "Otro"
      ))
  */
  const getClasificaciónSobrecostos = (item: ObraApp) => {
    let result = null;
    const AU = item.sobrecostosMaterializados;
    if (AU! >= Sheet5.rangoSobreplazo[0].De) {
      if (AU! <= Sheet5.rangoSobreplazo[0].Hasta) {
        result = Sheet5.rangoSobreplazo[0].Rango;
      } else if (AU! <= Sheet5.rangoSobreplazo[1].Hasta) {
        result = Sheet5.rangoSobreplazo[1].Rango;
      } else if (AU! <= Sheet5.rangoSobreplazo[2].Hasta) {
        result = Sheet5.rangoSobreplazo[2].Rango;
      } else if (AU! <= Sheet5.rangoSobreplazo[3].Hasta) {
        result = Sheet5.rangoSobreplazo[3].Rango;
      }
    } else {
      result = "Otro";
    }
    return result;
  };

  /*
  col: AW
  Plazo inicial por km
  Formula =SI(O(AL37="";L37="");"";SI.ERROR(AL37/L37;""))
  */
  const getPlazoInicialKm = (item: ObraApp) => {
    let result = null;
    const S = item.plazoInicialMeses;
    const L = item.longitudKm;
    if (!S || !L) {
      result = 0;
    } else if (S && L) {
      result = S / L;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: AX
  Plazo vigente por km
  Formula =SI(O(AL37="";L37="");"";SI.ERROR(AL37/L37;""))
  */
  const getPlazoVigenteKm = (item: ObraApp) => {
    let result = null;
    const AL = item.plazoContractualVigente;
    const L = item.longitudKm;
    if (!AL || !L) {
      result = 0;
    } else if (AL && L) {
      result = AL / L;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: AY
  Año de finalización del contrato
  Formula =SI(T37="";"";SI.ERROR(AÑO(T37);""))
  */
  const getAñoFinalizacionContratos = (item: ObraApp) => {
    let result = null;
    const T = item.fechaFinalizacionVigente;
    if (!T) {
      result = 0;
    } else if (T) {
      result = new Date(T).getFullYear();
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: AZ
  2020
  Formula =SI(AY37="";"";SI(AY37>=$AZ$2;"2020";0))
  */
  const get2020 = (item: ObraApp) => {
    let result = null;
    const AY = item.anoFinalizaciónContrato;
    const AZ = item._2020!;
    if (!AY) {
      result = 0;
    } else if (AY >= AZ) {
      result = AZ;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: BA
  2021
  Formula =SI(AY37="";"";SI(AY37>=$AZ$2;"2020";0))
  */
  const get2021 = (item: ObraApp) => {
    let result = null;
    const AY = item.anoFinalizaciónContrato;
    const BA = item._2021!;
    if (!AY) {
      result = 0;
    } else if (AY >= BA) {
      result = BA;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: BB
  2022
  Formula =SI(AY37="";"";SI(AY37>=$AZ$2;"2020";0))
  */
  const get2022 = (item: ObraApp) => {
    let result = null;
    const AY = item.anoFinalizaciónContrato;
    const BB = item._2022!;
    if (!AY) {
      result = 0;
    } else if (AY >= BB) {
      result = BB;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: BC
  2023
  Formula =SI(AY37="";"";SI(AY37>=$AZ$2;"2020";0))
  */
  const get2023 = (item: ObraApp) => {
    let result = null;
    const AY = item.anoFinalizaciónContrato;
    const BC = item._2023!;
    if (!AY) {
      result = 0;
    } else if (AY >= BC) {
      result = BC;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: BD
  2024
  Formula =SI(AY37="";"";SI(AY37>=$AZ$2;"2020";0))
  */
  const get2024 = (item: ObraApp) => {
    let result = null;
    const AY = item.anoFinalizaciónContrato;
    const BD = item._2024!;
    if (!AY) {
      result = 0;
    } else if (AY >= BD) {
      result = BD;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: BE
  2025
  Formula =SI(AY37="";"";SI(AY37>=$AZ$2;"2020";0))
  */
  const get2025 = (item: ObraApp) => {
    let result = null;
    const AY = item.anoFinalizaciónContrato;
    const BE = item._2025!;
    if (!AY) {
      result = 0;
    } else if (AY >= BE) {
      result = BE;
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: BF
  Nota Final: Sobrecostos
  Formula ==SI(AU3="";"";
     SI(AU3<Sheet5!$P$23;Sheet5!$N$23;
      SI(AU3<=Sheet5!$P$24;Sheet5!$N$24;Sheet5!$N$25)))
  */
  const getNotaFinalSobrecostos = (item: ObraApp) => {
    let result: any;
    const AU = item.sobrecostosMaterializados;
    if (!AU) {
      result = null;
    } else if (AU! < Sheet5.rangoSobrecostoNotaFinal[0].Hasta!) {
      result = Sheet5.rangoSobrecostoNotaFinal[0].Rango;
    } else if (AU! <= Sheet5.rangoSobrecostoNotaFinal[1].Hasta!) {
      result = Sheet5.rangoSobrecostoNotaFinal[1].Rango;
    } else {
      result = Sheet5.rangoSobrecostoNotaFinal[2].Rango;
    }
    return result;
  };

  /*
  col: BG
  Nota Final: Sobreplazo
  Formula =SI(AT267="";"";
   SI(AT267<Sheet5!$P$29;Sheet5!$N$29;
     SI(AT267<=Sheet5!$P$30;Sheet5!$N$30;Sheet5!$N$31)))
  */
  const getNotaFinalSobreplazo = (item: ObraApp) => {
    let result: any;
    const AT = item.sobrecostosMaterializados;
    if (!AT) {
      result = null;
    } else if (AT! < Sheet5.rangoSobreplazoNotaFinal[0].Hasta!) {
      result = Sheet5.rangoSobreplazoNotaFinal[0].Rango;
    } else if (AT! <= Sheet5.rangoSobreplazoNotaFinal[1].Hasta!) {
      result = Sheet5.rangoSobreplazoNotaFinal[1].Rango;
    } else {
      result = Sheet5.rangoSobreplazoNotaFinal[2].Rango;
    }
    return result;
  };

  /*
  col: BH
  Nota Final: Estado general
  Formula =SI(O(AR267="";AT267="");"";
  SI(AR267>=AT267;"Green";
  SI(AT267>=AR267-0,1;"Orange";
  SI(AR267-0,1>AT267;"Red"; "Revisar")
  )
  ))
  */
  const getNotaFinalEstadoGeneral = (item: ObraApp) => {
    let result: any;
    const AR = item.porcentajeAvanceDePlazo;
    const AT = item.porcentajeAvanceAcumulado;
    if (!AR || !AT) {
      result = null;
    } else if (AR >= AT) {
      result = "Green";
    } else if (AT >= AR - 0.1) {
      result = "Orange";
    } else if (AR - 0.1 > AT) {
      result = "Red";
    } else {
      result = "Revisar";
    }
    return result;
  };

  /*
  col: BI
  Sub-region
  Formula =SI(D3781="AR";"CSC";
  SI(D3781="PR";"CSC";
  SI(D3781="UR";"CSC";
  SI(D3781="PR";"CSC";
  SI(D3781="BR";"CSC";
  SI(D3781="EC";"CAN";
  SI(D3781="CO";"CAN";
  SI(D3781="BO";"CAN";
  SI(D3781="PE";"CAN";
  SI(D3781="PN";"CID";
  SI(D3781="CR";"CID";
  SI(D3781="NI";"CID";
  SI(D3781="HO";"CID";
  SI(D3781="HA";"CID";
  SI(D3781="BL";"CID";
  SI(D3781="GY";"CCB";
  "Otro"))
    ))))))))))))))
  */
  const getSubRegion = (item: ObraApp) => {
    let result = null;
    const D = item.paisItem?.nombre;
    if (
      D === "Argentina" ||
      D === "Paraguay" ||
      D === "Uruguay" ||
      D === "Brasil"
    ) {
      result = "CSC";
    } else if (
      D === "Ecuador" ||
      D === "Colombia" ||
      D === "Bolivia" ||
      D === "Perú"
    ) {
      result = "CAN";
    } else if (
      D === "Panama" ||
      D === "Costa Rica" ||
      D === "Nicaragua" ||
      D === "Honduras" ||
      D === "HA" ||
      D === "Belize"
    ) {
      result = "CID";
    } else if (D === "Guyana") {
      result = "CCB";
    } else {
      result = "Otro";
    }
    return result;
  };

  /*
  col: CF
  sobrecostos USD
  Formula =SI.ERROR(AD3-AB3;"")
  */
  const getSobrecostosUSD = (item: ObraApp) => {
    let result = null;
    const AD = item.montoContractualVigenteModificadoDolares;
    const AB = item.montoContractualDolares;
    if (AD && AB) {
      result = Number((AD - AB).toFixed(2));
    } else {
      result = 0;
    }
    return result;
  };

  /*
  col: CG
  sobrecostos USD en millones
  Formula =SI.ERROR((AD3-AB3)/1000000;0)
  */
  const getSobrecostosUSDEnMillones = (item: ObraApp) => {
    let result = null;
    const AD = item.montoContractualVigenteModificadoDolares;
    const AB = item.montoContractualDolares;
    if (AD && AB) {
      result = (AD - AB) / 1000000;
    } else {
      result = 0;
    }
    return result;
  };

  /*
    col: CJ
    FIC Metodológico de contratos activos
    Formula: =SI(O(Y1233="En ejecución";Y1233="Paralizada";Y1233="En cierre/liquidacion";Y1233="Finalizada";Y1233="Rescindido");
                  (SI(O(AD1233="";AB1233="");""; SI.ERROR((AD1233-AB1233)/AB1233;"")));"")
  */
  const getFICMetodologicoContratosActivos = (item: ObraApp) => {
    let result = null;
    const Y = item.estadoEjecucion;
    const AD = item.montoContractualVigenteModificadoDolares;
    const AB = item.montoContractualDolares;
    if (Y !== (Sheet2.estadoEjecucion[4].id)) {
      if (!AD || !AB) {
        result = null;
      } else {
        result = Number(((AD - AB) / AB).toFixed(2));
      }
    } else {
      result = null;
    }
    return result;
  };

  /*
    col: CK
    FPC Metodológico de contratos activos
    Formula: =SI(O(Y2501="En ejecución";Y2501="Paralizada");
                (SI(O(AK2501="";S2501="");"";SI(((AK2501-S2501)/S2501)>0;(AK2501-S2501)/S2501;0)));"")
    */
  const getFPCMetodologicoContratosActivos = (item: ObraApp) => {
    let result = null;
    const Y = item.estadoEjecucion;
    const AD = item.montoContractualVigenteModificadoDolares;
    const AB = item.montoContractualDolares;
    if (Y) {
      if (!AD || !AB) {
        result = null;
      } else if (AD && AB) {
        result = Number(((AD - AB) / AB).toFixed(2));
      }
    } else {
      result = null;
    }
    return result;
  };

  /*
    col: CL
    FIC Metodológico de contratos activos (sin ceros)
    Formula: =+SI(CI3=0;"";CI3)
    */
  const getFICMetodologicoContratosActivosSinCEROS = (item: ObraApp) => {
    let result = null;
    const CI = item.ficmetodologicoContratosActivos;
    if (CI === 0 || !CI) {
      result = 0;
    } else {
      result = Number((CI).toFixed(2));
    }
    return result;
  };

  /*
    col: CM
    FPC Metodológico de contratos activos (sin ceros)
    Formula: =+SI(CI3=0;"";CI3)
    */
  const getFPCMetodologicoContratosActivosSinCEROS = (item: ObraApp) => {
    let result = null;
    const CL = Number(item.fpcmetodologicoContratosActivos);
    if (CL === 0 || !CL) {
      result = 0;
    } else {
      result = Number((CL).toFixed(2));
    }
    return result;
  };

  /*
    col: CN
    Ponderador FIC MCA
    Formula: =+SI.ERROR(SI(CI3="";"";1)*AB3;"")
    */
  const getPonderadorFICMCA = (item: ObraApp) => {
    let result = null;
    const CI = item.ficmetodologicoContratosActivos;
    const AB = item.montoContractualDolares;
    if (CI || AB) {
      if (CI === 0 || !CI) {
        result = 0;
      } else {
        result = 1;
      }
      result = Number((result * AB!).toFixed(1));
    } else {
      result = null;
    }
    return result;
  };

  /*
    col: CO
    Ponderador PFC
    Formula: =+SI.ERROR(SI(CJ3="";"";1)*S3;"")
    */
  const getPonderadorPFC = (item: ObraApp) => {
    let result = null;
    const CJ = Number(item.fpcmetodologicoContratosActivos);
    const S = item.plazoInicialMeses;
    if (CJ || S) {
      if (CJ === 0 || !CJ || CJ == null) {
        result = 0;
      } else {
        result = 1;
      }
      result = Number((result * S!).toFixed(1));
    } else {
      result = null;
    }
    return result;
  };

  /*
    col: CP
    Ponderador FIC MCA sin ceros 
    Formula: =+SI.ERROR(SI(CK3="";"";1)*AB3;"")
    */
  const getPonderadorFICMCASinCEROS = (item: ObraApp) => {
    let result = null;
    const CK = item.ficmetodologicoContratosActivosSinCeros;
    const AB = item.montoContractualDolares;
    if (CK || AB) {
      if (CK === 0 || !CK || CK == null) {
        result = 0;
      } else {
        result = 1;
      }
      result = Number((result * AB!).toFixed(1));
    } else {
      result = null;
    }
    return result;
  };

  /*
    col: CQ
    Ponderador PFC MCA sin ceros 
    Formula: =+SI.ERROR(SI(CL3="";"";1)*S3;"")
    */
  const getPonderadorPFCMCASinCEROS = (item: ObraApp) => {
    let result: any;
    const CL = Number(item.fpcmetodologicoContratosActivosSinCeros);
    const S = item.plazoInicialMeses;
    let operation: number;
    if (S) {
      if (CL === 0 || !CL) {
        operation = 0;
      } else {
        operation = 1;
      }
      result = Number((operation * S).toFixed(1));
    } else {
      result = "";
    }
    return result;
  };

  /*
  col: CR
  Fecha de orden de inicio en mes año
  Formula =+SI(R3="";"";FECHA(AÑO(R3);MES(R3);10))
  */
  const getFechaOrdenInicioEnMesAño = (item: ObraApp) => {
    let result = null;
    const R = item.fechaInicio;
    const month = new Date(R!).getMonth();
    const year = new Date(R!).getFullYear();
    if (R === null || undefined) {
      result = null;
    } else {
      result = 10 + "/" + (month + 1) + "/" + year;
    }
    return result;
  };

  /*
  col: CS
  Mes del último pago al contratista en mes año
  Formula =+SI(W3="";"";FECHA(AÑO(W3);MES(W3);10))
  */
  const getMesUltimoPagoContratistaMesAño = (item: ObraApp) => {
    let result = null;
    const W = item.fechaInicio;
    const month = new Date(W!).getMonth();
    const year = new Date(W!).getFullYear();
    if (W === null || undefined) {
      result = null;
    } else {
      result = 10 + "/" + (month + 1) + "/" + year;
    }
    return result;
  };

  /*
  col: CW
  Monto contractual inicial en dólares con tasa de cambio por mes y moneda según fecha de inicio de obras
  Formula =+SI(O(N3="";CT3="");"";N3*CT3)
  */
  const getMontoContractualInicialDolaresTasaCambioMesYMoneda = (
    item: ObraApp
  ) => {
    let result = null;
    const N = item.montoInicial;
    const CT = item.tipoCambio;
    if (!N || !CT) {
      result = null;
    } else {
      result = Number((N * CT).toFixed());
    }
    return result;
  };

  /*
  col: CX
  Monto Contractual Vigente / modificado (dólares) con tasa de cambio por mes y moneda
  Formula =+SI(O90="";"";O90*CS90)
  */
  const getMontoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda = (
    item: ObraApp
  ) => {
    let result = null;
    const O = item.montoVigente;
    const CS = item.tipoCambio;
    if (!O) {
      result = null;
    } else {
      result = Number((O * CS!).toFixed());
    }
    return result;
  };

  /*
  col: CY
  FIC con tazas de cambio diferenciadas
  Formula =+SI(O(CW90="";CV90="");"";SI.ERROR(SI(O((CW90-CV90)/CV90=0;Y((CW90-CV90)/CV90>0;(CW90-CV90)/CV90<0,001));"";(CW90-CV90)/CV90);""))
  */
  const getFicConTazasCambioDiferenciadas = (item: ObraApp) => {
    let result = null;
    const CW =
      item.montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda;
    const CV = item.montoContractualInicialDolaresTasaCambioMesYMoneda;
    if (!CW || !CV) {
      result = 0;
    } else {
      if ((CW - CV) / CV >= 0 && (CW - CV) / CV < 0.001) {
        result = 0;
      } else {
        result = (CW - CV) / CV;
      }
    }
    return result;
  };



  return {
    getMontoContractualDolares,
    getMontoContractualEnDolaresMillones,
    getMontoContractualVigenteModificadoDolares,
    getMontoContractualVigenteModificadoDolaresEnMillones,
    getTotalPagoHastaLaFechaDolares,
    getClasificacionporkm,
    getClasificacionPorMontos,
    getPrecioInicialPorKmMillones,
    getPrecioVigentePorKmMillones,
    getClasificacionPorPlazo,
    getSobreplazoCalculadoMeses,
    getClasificacionPorSobreplazo,
    getAvancePlazoPlazoIntermedio,
    getPorcentajeAvancePlazo,
    getEstadoAvanceGeneral,
    getPorcentajeAvanceAcumulado,
    getPlazoContractualVigentePasoIntermedio,
    getPlazoContractualVigente,
    getSobrecostosMaterializados,
    getClasificaciónSobrecostos,
    getPlazoInicialKm,
    getPlazoVigenteKm,
    getAñoFinalizacionContratos,
    get2020,
    get2021,
    get2022,
    get2023,
    get2024,
    get2025,
    getNotaFinalSobrecostos,
    getNotaFinalSobreplazo,
    getNotaFinalEstadoGeneral,
    getSubRegion,
    getSobrecostosUSD,
    getSobrecostosUSDEnMillones,
    getFICMetodologicoContratosActivos,
    getFPCMetodologicoContratosActivos,
    getFICMetodologicoContratosActivosSinCEROS,
    getFPCMetodologicoContratosActivosSinCEROS,
    getPonderadorFICMCA,
    getPonderadorPFC,
    getPonderadorFICMCASinCEROS,
    getPonderadorPFCMCASinCEROS,
    getFechaOrdenInicioEnMesAño,
    getMesUltimoPagoContratistaMesAño,
    getMontoContractualInicialDolaresTasaCambioMesYMoneda,
    getMontoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda,
    getFicConTazasCambioDiferenciadas,
  };
}
